// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".b42b57{display:flex;flex-direction:column;color:var(--secondary);height:100%;justify-content:space-between}.b42b57 li{position:relative;border-top:1px dashed var(--subtle);margin-left:var(--left-gutter)}.b42b57 li.f5f43a{border-top-style:solid}.b42b57 li:first-child,.b42b57 li:last-child{visibility:hidden}._62c556{font-size:.75em;position:absolute;top:-0.75em;white-space:nowrap;left:calc(-1*var(--left-gutter) - 1rem);width:var(--left-gutter);text-align:right}", ""]);
// Exports
exports.locals = {
	"timegrid": "b42b57",
	"middle": "f5f43a",
	"label": "_62c556"
};
module.exports = exports;
